<div class="overflow-auto rounded-t-lg scroll-style h-full scrollbar-width-thin">
  <ng-content select="mat-table, [mat-table]"></ng-content>
</div>

<ng-content select="mat-paginator, [paginator]"></ng-content>
